export const    ACTIVITY = 'ACTIVITY';
export const    ACTIVITY_SUCCESS = 'ACTIVITY_SUCCESS';
export const    ACTIVITY_ERROR = 'ACTIVITY_ERROR';

export const    ACTIVITY_DETAIL = 'ACTIVITY_DETAIL';
export const    ACTIVITY_DETAIL_SUCCESS = 'ACTIVITY_DETAIL_SUCCESS';
export const    ACTIVITY_DETAIL_ERROR = 'ACTIVITY_DETAIL_ERROR';

export const ACTIVITY_TAGS = 'ACTIVITY_TAGS';
export const ACTIVITY_TAGS_SUCCESS = 'ACTIVITY_TAGS_SUCCESS';
export const ACTIVITY_TAGS_ERROR = 'ACTIVITY_TAGS_ERROR';

export const ACTIVITY_FILTERS = 'ACTIVITY_FILTERS';
export const ACTIVITY_FILTERS_SUCCESS = 'ACTIVITY_FILTERS_SUCCESS';
export const ACTIVITY_FILTERS_ERROR = 'ACTIVITY_FILTERS_ERROR';

export const    CALENDAR_ACTIVITY = 'CALENDAR_ACTIVITY';
export const    CALENDAR_ACTIVITY_SUCCESS = 'CALENDAR_ACTIVITY_SUCCESS';
export const    CALENDAR_ACTIVITY_ERROR = 'CALENDAR_ACTIVITY_ERROR';

export const    ADD_ACTIVITY = 'ADD_ACTIVITY';
export const    ADD_ACTIVITY_SUCCESS = 'ADD_ACTIVITY_SUCCESS';
export const    ADD_ACTIVITY_ERROR = 'ADD_ACTIVITY_ERROR';

export const    UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const    UPDATE_ACTIVITY_SUCCESS = 'UPDATE_ACTIVITY_SUCCESS';
export const    UPDATE_ACTIVITY_ERROR = 'UPDATE_ACTIVITY_ERROR';

export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const DELETE_ACTIVITY_SUCCESS= 'DELETE_ACTIVITY_SUCCESS';
export const DELETE_ACTIVITY_ERROR ='DELETE_ACTIVITY_ERROR';

export const DELETE_ACTIVITIES = 'DELETE_ACTIVITIES';
export const DELETE_ACTIVITIES_SUCCESS= 'DELETE_ACTIVITIES_SUCCESS';
export const DELETE_ALL_ACTIVITIES_SUCCESS= 'DELETE_ALL_ACTIVITIES_SUCCESS';
export const DELETE_ACTIVITIES_ERROR ='DELETE_ACTIVITIES_ERROR';

export const DELETE_RECURRENCE_ACTIVITY = 'DELETE_RECURRENCE_ACTIVITY';
export const DELETE_RECURRENCE_ACTIVITY_SUCCESS= 'DELETE_RECURRENCE_ACTIVITY_SUCCESS';
export const DELETE_RECURRENCE_ACTIVITY_ERROR ='DELETE_RECURRENCE_ACTIVITY_ERROR';


export const    ADD_DETAILS_IMAGE = 'ADD_DETAILS_IMAGE';
export const    ADD_DETAILS_IMAGE_SUCCESS = 'ADD_DETAILS_IMAGE_SUCCESS';
export const    ADD_DETAILS_IMAGE_ERROR = 'ADD_DETAILS_IMAGE_ERROR';

export const    ADD_THUMBNAIL_IMAGE = 'ADD_THUMBNAIL_IMAGE';
export const    ADD_THUMBNAIL_IMAGE_SUCCESS = 'ADD_THUMBNAIL_IMAGE_SUCCESS';
export const    ADD_THUMBNAIL_IMAGE_ERROR = 'ADD_THUMBNAIL_IMAGE_ERROR';


export const    GET_ACTIVITIES_IMAGES = 'GET_ACTIVITIES_IMAGES';
export const    GET_ACTIVITIES_IMAGES_SUCCESS = 'GET_ACTIVITIES_IMAGES_SUCCESS';
export const    GET_ACTIVITIES_IMAGES_ERROR = 'GET_ACTIVITIES_IMAGES_ERROR';
